import { useEffect, useRef } from 'react'
import cx from 'classnames'
import { Loader } from '@googlemaps/js-api-loader'

const MAP_ID = '83bb7a7bf74e145f' // https://console.cloud.google.com/google/maps-apis/studio/maps?project=acre-347621

const ListingMap = ({
  lat,
  lng,
  className,
}: {
  lat: number
  lng: number
  className?: string
}) => {
  const mapRef = useRef(null)

  useEffect(() => {
    const loader = new Loader({
      apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? '',
      version: 'weekly',
    })

    loader.load().then((google) => {
      const map = new google.maps.Map(mapRef.current, {
        center: { lat, lng },
        zoom: 16,
        mapId: MAP_ID,
      })
      new google.maps.Marker({
        position: { lat, lng },
        map: map,
      })
    })
  }, [lat, lng])

  return <div id="map" ref={mapRef} className={cx(className, 'aspect-3/2')} />
}

export default ListingMap
